export const FIELD_STATUS = [
  "documentato",
  "confermato_agente",
  "da_appunto",
  "dedotto_foto",
  "probabile",
  "mancante",
] as const;
export type FieldStatus = (typeof FIELD_STATUS)[number];

export const LISTING_STATUS = [
  "bozza",
  "disponibile",
  "prezzo_su_richiesta",
  "in_trattativa",
  "riservato",
  "venduto",
  "archiviato",
] as const;
export type ListingStatus = (typeof LISTING_STATUS)[number];

export const PUBLIC_LISTING_STATUS: ListingStatus[] = [
  "disponibile",
  "prezzo_su_richiesta",
  "in_trattativa",
  "riservato",
];

export const ROLE = ["owner", "admin", "editor", "reviewer", "viewer"] as const;
export type Role = (typeof ROLE)[number];

export const INQUIRY_STATUS = ["nuovo", "visto", "in_carico", "chiuso"] as const;
export type InquiryStatus = (typeof INQUIRY_STATUS)[number];

export const PUBLICATION_BLOCKING_FIELDS = [
  "ape",
  "mq",
  "prezzo",
  "piano",
  "disponibilita",
] as const;
